import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import 'semantic-ui-css/semantic.min.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

import {createStore, applyMiddleware, compose} from 'redux'
import { Provider } from "react-redux"
import thunk from 'redux-thunk'
import RootR from './store/reducers/RootR'
import registerPdfFonts from './utils/pdfFonts'

function saveToLocalStorage(state) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch(e) {
    console.log(e);
  }
}

function loadFromLocalStorage() {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch(e) {
    console.log(e);
  }
}

const persistedState = loadFromLocalStorage();

const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
    RootR,
    persistedState,
    storeEnhancers(
      applyMiddleware(thunk)
    )
)

store.subscribe(() => saveToLocalStorage(store.getState()));

// A downloaded card must spell a learner's name the way the school does.
registerPdfFonts()

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
